import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import Stepper, { StepperClasskey } from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import StepContent from "@material-ui/core/StepContent";
import DataClient from "../../../../../../Service/general_data_service";
import { Box, Button, Grid, Typography, Tooltip } from "@material-ui/core";
import DateComponent from "../../../../../../Components/FormGenerator/datepicker_component";
import CustomInput from "../../../../../../Components/CustomInput";
import moment from "moment";
import { showSnackbar } from "../../../../../../Components/Snackbar/SnackbarActions";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import ActivityLogModal from "./ActivityLogModal";
import { Mail } from "@material-ui/icons";
import StepIconComponent from "./StepIconComponent";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  button: {
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  actionsContainer: {
    marginBottom: theme.spacing(2),
  },
  resetContainer: {
    padding: theme.spacing(3),
  },
  errorLog: {
    color: "#ff0000",
  },
  labelContainer: {
    display: "flex",
    alignItems: "center",
  },

  actionButton: {
    cursor: "pointer",
  },
  active: {
    height: "9px",
    width: "9px",
    borderRadius: "50%",
    marginLeft: "10px",
  },
  stepper: {
    padding: "10px 0px",
    // "& .MuiStepConnector-root": {
    //     "& .MuiStepConnector-line": {
    //         borderColor: "#077F83"
    //     }
    // },
    "& .MuiStepIcon-text": {
      fill: "white",
    },
    "& .MuiStepIcon-root": {
      color: "rgba(0, 0, 0, 0.38) !important",
    },
    "& .MuiStepIcon-active": {
      color: "#077F83 !important",
    },
  },
}));

export default function ActivityLog(props) {
  //permission
  const permission = useSelector((state) => state.commonReducer);

  // const displayPermission =
  //   permission.accessPermission?.assignmentDetail?.assignmentOverview
  //     .activityLog;
  const displayPermission = {
    displayAddButton: true,
    displayDeleteIcon: true,
    displayEditIcon: true,
  };

  const classes = useStyles();
  const dispatch = useDispatch();
  const errorEnum = {
    activity_name: "",
    comments: "",
    date: false,
    addToPrograms: false,
  };
  const [activityLogDetails, setActivityLogDetails] = useState([]);
  const [activityData, setActivityData] = useState(errorEnum);
  const [errorLogs, setErrorLogs] = useState({
    activity_name: false,
    date: false,
  });
  const [loading, setLoading] = useState(false);
  const [addNewLog, setAddNewLog] = useState(false);

  const AssignmnetId = props.location?.state?.currentAssignment?.id;

  const setInputState = (inputStateValue, inputField, index) => {
    setActivityLogDetails((oldvalue) => {
      return oldvalue.map((item, itemIndex) => {
        if (itemIndex === index) {
          item[inputField] = inputStateValue || "";
        }
        return item;
      });
    });
  };
  console.log("activityLogDetails", activityLogDetails);
  console.log("activityData", activityData);
  const setNewInputState = (inputStateValue, inputId) => {
    setErrorLogs({ ...errorLogs, [inputId]: false });
    setActivityData({ ...activityData, [inputId]: inputStateValue });
  };

  useEffect(() => {
    getActivityLog();
  }, []);

  const getActivityLog = () => {
    DataClient.getData("activity_logs?assignment_id=" + AssignmnetId)
      .then((res) => {
        if (res?.success) {
          const activityLog = res?.activity_logs.map((item) => {
            return {
              ...item,
              isEdit: false,
              newDate: item?.date,
              newComments: item?.comments,
              is_added_by_client: item?.created_by_client || false,
            };
          });
          setActivityLogDetails(activityLog);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const globaluserData = useSelector((state) => state.commonReducer);
  let role = globaluserData.role;
  // let role = sessionStorage.getItem("role");
  const saveActivityDetails = (isEdit, index) => {
    let isError = false;
    setLoading(true);
    if (isEdit) {
      const formData = activityLogDetails[index];
      if (!formData?.newDate) {
        isError = true;
        setActivityLogDetails((oldValue) => {
          return oldValue.map((item, itemIndex) => {
            if (itemIndex === index) {
              return { ...item, newDateError: true };
            }
            return item;
          });
        });
      }
      if (!isError) {
        const pdata = {
          assignment_id: AssignmnetId,
          date: moment(formData.newDate).format("DD-MM-YYYY"),
          activity_log_id: formData.id,
          comments: formData.newComments,
        };

        DataClient.update(pdata, "/activity_logs/update_activity_log")
          .then((res) => {
            if (res?.success) {
              dispatch(showSnackbar("Success", [res.message]));
              getActivityLog();
              handleClose();
              setLoading(false);
            }
          })
          .catch((error) => {
            console.log(error);
            setLoading(false);
          });
      } else setLoading(false);
    } else {
      if (!activityData?.activity_name) {
        isError = true;
        setErrorLogs((oldValue) => ({ ...oldValue, activity_name: true }));
      }
      if (!activityData?.date) {
        isError = true;
        setErrorLogs((oldValue) => ({ ...oldValue, date: true }));
      }
      if (!isError) {
        const pdata = {
          assignment_id: AssignmnetId,
          activity_name: activityData.activity_name,
          date: moment(activityData.date).format("DD-MM-YYYY"),
          comments: activityData.comments,
          add_to_programme: `${activityData.addToPrograms}`,
          // is_added_by_client: `${false}`,
          // programmme_id: 2,
        };
        // if (role === "employee") {
        //   pdata["is_added_by_client"] = true;
        // }

        DataClient.create(pdata, "activity_logs")
          .then((res) => {
            if (res?.success) {
              setActivityLogDetails([]);
              dispatch(showSnackbar("Success", [res.message]));
              getActivityLog();
              handleClose();
              setLoading(false);
            }
          })
          .catch((error) => {
            console.log(error);
            setLoading(false);
          });
      } else setLoading(false);
    }
  };

  const handleClose = () => {
    setAddNewLog(false);
    setActivityData({
      ...activityData,
      activity_name: "",
      comments: "",
      date: null,
      addToPrograms: false,
    });
    setErrorLogs(errorEnum);
  };

  const handleEditLog = (index) => {
    setAddNewLog(false);
    setActivityLogDetails((oldValue) => {
      return oldValue.map((item, itemIndex) => {
        if (itemIndex === index) {
          return { ...item, isEdit: !item.isEdit, newDate: item.date };
        }
        return { ...item, isEdit: false };
      });
    });
  };

  const addNewHandler = () => {
    setActivityLogDetails((oldValue) => {
      return oldValue.map((item, itemIndex) => {
        return { ...item, isEdit: false };
      });
    });
    setAddNewLog(true);
  };

  const deleteHandler = (id) => {
    const pdata = {
      assignment_id: AssignmnetId,
      activity_log_id: id,
    };
    setLoading(true);
    DataClient.remove("/activity_logs/delete_activity_log", pdata)
      .then((res) => {
        if (res?.success) {
          dispatch(showSnackbar("Success", [res.message]));
          getActivityLog();
          handleClose();
          setLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };
  const emailDateBlueFields = [
    "Date of acknowledgement",
    "Coaching Initiation acknowledgement date",
    "Pre Questionnaire Form sent date",
    "Pre Questionnaire Form acknowledgement date",
    "Date of 360 Approval email to client",
    "Psychometrics Used Approval email",
    "Review form sent date",
    "Review form acknowledgment sent date",
    "Review questionnaire Coachee/LM/Coach",
    "Request to continue coaching following Review",
    "Invoicing process requested  date",
    "PO requested  date",
  ];

  const emailDatePurpleFields = [
    "Coaches Contacted date",
    "Short List Sent date",
    "Reminder shortlist to coachee/HR",
    "Unsuccessful selection for chemsitry",
    "Successful selection for chemistry",
    "Unsuccessful selection from chemsitry",
    "Confirmation emails sent dates for all stakeholders",
  ];

  return (
    <Grid container style={{ width: "73.5%" }}>
      {displayPermission?.displayAddButton && (
        <Grid item xs={12}>
          <Button
            variant="contained"
            style={{
              textTransform: "inherit",
              marginTop: "15px",
              marginRight: "0px",
              float: "right",
            }}
            color="secondary"
            onClick={addNewHandler}
          >
            + Add new
          </Button>
        </Grid>
      )}
      {!displayPermission?.displayAddButton && (
        <Grid item xs={12} style={{ height: "32px" }}></Grid>
      )}
      <Grid item xs={11}>
        <Stepper orientation="vertical" className={classes.stepper}>
          {activityLogDetails?.map((item, index) => (
            <Step
              key={index}
              active={true}
              style={{ border: "none", padding: "0px", margin: "0px" }}
            >
              <StepLabel
                classes={{
                  label: classes.labelContainer,
                }}
                StepIconComponent={() => {
                  return (
                    <StepIconComponent
                      createdByEmail={item.created_by_email}
                      slNo={index + 1}
                    />
                  );
                }}
              >
                <Typography
                  variant="h2"
                  style={{
                    flexBasis: "90%",
                    display: "flex",
                    alignItems: "center",
                    color: "black",
                  }}
                >
                  <span
                  // style={{
                  //   color: emailDateBlueFields.includes(item.activity_name)
                  //     ? "#0170c0"
                  //     : "black",
                  // }}
                  >
                    {item.activity_name}
                  </span>
                  <div
                    className={classes.active}
                    style={{
                      backgroundColor: item?.date
                        ? "#4FC605"
                        : "rgb(255, 152, 0)",
                    }}
                  ></div>
                </Typography>

                {!item?.isEdit && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    {(role === "admin"
                      ? displayPermission?.displayEditIcon
                      : displayPermission?.displayEditIcon &&
                        item.is_added_by_client) && (
                      <Tooltip title="Edit">
                        <EditIcon
                          fontSize="small"
                          color="primary"
                          className={classes.actionButton}
                          onClick={() => handleEditLog(index)}
                        />
                      </Tooltip>
                    )}
                    {(role === "admin"
                      ? displayPermission?.displayDeleteIcon
                      : displayPermission?.displayDeleteIcon &&
                        item.is_added_by_client) && (
                      <Tooltip title="Delete">
                        <DeleteIcon
                          fontSize="small"
                          style={{ marginLeft: "10px" }}
                          color="error"
                          className={classes.actionButton}
                          onClick={() => deleteHandler(item?.id)}
                        />
                      </Tooltip>
                    )}
                  </div>
                )}
              </StepLabel>
              {item?.isEdit ? (
                <StepContent key={"StepContent" + item.id}>
                  <Box sx={{ ml: 1, mt: 2 }}>
                    <Grid container direction="row" spacing={2}>
                      <Grid item xs={4}>
                        <CustomInput
                          id="activity_name"
                          multiline
                          rows="4"
                          variant="outlined"
                          placeholder="Comments"
                          name="comments"
                          parentcall={(value) =>
                            setInputState(value, "newComments", index)
                          }
                          value={item?.newComments}
                        />
                      </Grid>
                      <Grid item xs={4} marginLeft={"20px"}>
                        <DateComponent
                          key={index + "picker"}
                          componentObject={{
                            componentType: "datePicker",
                            required: true,
                            name: "date",
                            placeholder: "Date",
                            helperText: false,
                            indexKey: item.id + "textField",
                            index: item.id,
                            handleChange: (value) =>
                              setInputState(value, "newDate", index),
                            value: item?.newDate ? moment(item?.newDate) : "",
                            customStyle: { marginBottom: "2px" },
                          }}
                        />
                        {item?.newDateError ? (
                          <span className={classes.errorLog}>
                            Date is required.
                          </span>
                        ) : null}
                      </Grid>
                      <Grid item xs={4}>
                        <Button
                          disableElevation
                          variant="contained"
                          disabled={loading}
                          onClick={() => handleEditLog(index)}
                        >
                          Cancel
                        </Button>
                        <Button
                          disableElevation
                          disabled={loading}
                          variant="contained"
                          color="secondary"
                          onClick={() => saveActivityDetails(true, index)}
                          style={{ marginLeft: 10 }}
                        >
                          Save
                        </Button>
                      </Grid>
                    </Grid>
                  </Box>
                </StepContent>
              ) : (
                <StepContent>
                  {item?.date && (
                    <Typography
                      variant="h2"
                      style={{
                        fontSize: "14px",
                        // color: emailDatePurpleFields.includes(
                        //   item.activity_name
                        // )
                        //   ? "#7030a7"
                        //   : "black",
                      }}
                    >
                      {item.date}
                    </Typography>
                  )}
                  {item?.comments && (
                    <Typography
                      variant="h2"
                      style={{ marginTop: "0.25rem", fontSize: "14px" }}
                    >
                      Comments: {item.comments}
                    </Typography>
                  )}
                </StepContent>
              )}
            </Step>
          ))}
          {addNewLog && (
            <ActivityLogModal
              isOpen={addNewLog}
              setNewInputState={setNewInputState}
              activityData={activityData}
              errorLogs={errorLogs}
              onClose={() => handleClose()}
              onsubmit={() => saveActivityDetails(false, 0)}
              addToProgram={role === "admin"}
            />
          )}
        </Stepper>
      </Grid>
    </Grid>
  );
}
